import React, { useState, useEffect } from "react";
import "../style/Index.css";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import logo from "../assets/images/teteklogo-removebg-preview.png";

const LandingPage = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const candidateId = localStorage.getItem("cid");

  useEffect(() => {
    if (candidateId) {
      const fetchUserData = async () => {
        try {
          const response = await api.get(`employees/${candidateId}/`);
          setUserData(response.data);
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      };
      fetchUserData();
    }
  }, [candidateId]);

  const startTest = (topic) => {
    if (topic === "aptitude") {
      navigate("/ques");
    } else {
      navigate("/ques", { state: { topic } });
    }
  };

  const hasTakenAptitudeTest = userData && userData.count > 0;

  return (
    <div className="index__landing-container">
      {/* Header */}
      <div className="index__header">
        <div className="index__company-name">
          <img src={logo} alt="Logo" style={{ height: "45px", objectFit: "contain" }} />
        </div>
        <div className="index__title">AI Interview Mock Test</div>
        <div className="index__subtitle">
          Choose a section to begin your practice
        </div>
      </div>

      {/* Cards */}
      <div className="index__card-grid">
        {/* Aptitude Card */}
        <div className="index__card">
          <img
            src="https://cdn-icons-png.flaticon.com/512/3408/3408540.png"
            alt="Aptitude Icon"
            className="index__card-image"
          />
          <h2 className="index__card-title">Aptitude</h2>
          <button
            className="index__start-btn"
            onClick={() => startTest("aptitude")}
            disabled={hasTakenAptitudeTest}
          >
            {hasTakenAptitudeTest ? "Completed" : "Start Test"}
          </button>
        </div>

        {/* Technical Card */}
        <div className="index__card">
          <img
            src="https://cdn-icons-png.flaticon.com/512/2721/2721297.png"
            alt="Technical Icon"
            className="index__card-image"
          />
          <h2 className="index__card-title">Technical</h2>
          <button
            className="index__start-btn"
            onClick={() => navigate("/technical")}
            disabled={!hasTakenAptitudeTest}
          >
            Start Test
          </button>
        </div>
      </div>

      {/* Footer */}
      <footer className="index__footer">
        © 2025 Vienstereoptic. All rights reserved.
      </footer>
    </div>
  );
};

export default LandingPage;
